// @context TGW-2195 提供終了した公式／サンプリング企業のイベント（circle に
//   company_id または sampling_company_id が付いている）は新しい SectionPlans
//   でチケットを編集・追加できてしまうと、提供終了サービスの決済導線が復活する。
//   isCompanyOwnedCircle（is_company_owned カラム。コミュニティ扱いかどうか）とは
//   別概念のため、専用の判定関数として切り出す。
export const isLegacyServiceCircle = (circle) => {
  if (!circle) return false;
  return Boolean(circle.company_id) || Boolean(circle.sampling_company_id);
};
